<template>

  <section>
    <common-dialog
      v-dialog-drag
      center
      width="70%"
      :close-on-click-modal="false"
      @keydown.native.esc="handleCancel"
      :title="title"
      :visible.sync="selectMemberVisible">
      <section class="dialog-wrapper">
        <div v-loading="treeLoading" class="dialog-left-wrapper">
          <div class="dialog-left-wrapper-head">
            <el-input
              clearable
              placeholder="输入机构名、用户名、手机号进行过滤"
              v-model="filterText">
            </el-input>
          </div>
          <div class="dialog-left-wrapper-body">
            <el-tree
              :show-checkbox="true"
              style="height: 100%"
              class="filter-tree"
              :data.sync="treeData"
              node-key="id"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @check="handleTreeNodeCheck"
              ref="tree">
             <span class="custom-tree-node" slot-scope="{ node, data }">
                <span v-if="data.isMember" class="member-tree-node" @click="handleCheckNode(node, data)">
                  <span>{{ data.deptName }}</span>
                  <span class="member-name" style="color: #0d8efa">{{ data.name }}</span>
                </span>
                <span v-else>{{ node.label }}</span>
             </span>
            </el-tree>
          </div>
          <div class="dialog-left-wrapper-footer">
            <el-pagination
              @current-change="handleChangePage"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :current-page.sync="pagination.currentPage"
              :page-size="pagination.pageSize"
              :total="pagination.total">
            </el-pagination>
            <div class="footer-expand">
              <common-button image @click="handleClickSure">确定</common-button>
              <common-button image type="cancel" @click="handleCancel">取消</common-button>
            </div>
          </div>
        </div>
        <div class="dialog-right-wrapper">

          <div class="member-title" :style="type === 'add' ? '--color: #3ec0c4' : '--color: #e16969'">
            {{type === 'add' ? '添加列表' : '移除列表'}}
          </div>
          <div class="dialog-item-panel" v-if="members.length !== 0">

            <div class="member-item" :title="`${member.deptName} : ${member.name}`" v-for="(member,index) of members" :key="index">
              <div class="member-avatar" :style="`background-image: url(${avatarPre}/${member.avatar})`">

              </div>
              <div class="member-name">
                {{member.name}}
              </div>

            </div>

            <!--用于占位使用-->
            <div class="member-item" v-if="members.length !== 0" style="height: 0;margin-top: 0;margin-bottom: 0" v-for="i of 20"></div>
<!--            <div v-for="item of allCheckNode" class="member-item-wrapper">

              &lt;!&ndash;参与人是以人来选的&ndash;&gt;
              <div v-if="item.isMember" class="member-item">
                <span class="member-name-and-dept">
                  <span class="member-name">{{ item.name }}</span>
                  <span class="member-dept">{{ item.deptName }}</span>
                </span>
                <span class="member-section">{{ item.section }}</span>
              </div>

              &lt;!&ndash;参与人是以组来选择的&ndash;&gt;
              <div v-else class="member-item">
                <span class="member-label">{{ item.label }}</span>
                <span class="member-count">组内成员：{{ item | filterCount(that) }}人</span>
              </div>
            </div>-->

          </div>

          <div class="member-empty" v-if="members.length===0">
            <span class="empty-data-image" style="background-image: url('static/images/empty_data.png')"></span>
            没有参与人
          </div>

        </div>
      </section>
    </common-dialog>

    <animation :loading-data-visible="isLoading"></animation>

  </section>

</template>

<script>
import cookie from "@/utils/cookie";
import http from "@/utils/axios";
import Animation from "../loading/animation";
import {Message} from "element-ui";
import {mapState} from "vuex";

export default {
  name: "ParticipantDialog",
  components: {Animation},
  data() {
    return {

      defaultProps: {
        children: 'children',
        label: 'label'
      },

      that: this,
      filterText: null,
      finalMemberData: [],
      treeData: [],
      selectMemberVisible: false,
      dialogData: {},
      isLoading: false,
      treeLoading: false,
      loadingText: '保存中',

      //记录所有参与人的节点信息
      allCheckNode: [],
      flag: false,
      searchTimeout: null,

      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      //参与人
      members: [],

      avatarPre: window.config.avatar.baseUrl,

      //当前登录的用户id
      currUserId: "",
    }
  },

  props: {

    type:{
      type: String,
      default: "add",
    },

    visible: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: "选择参与人",
    },

    discuss: {
      type: Object,
      default: ()=>{
        return {}
      },
    },

    callback:{
      type: Function,
      default: ()=>{

      }
    },
  },

  watch: {

    filterText(val) {
      //触发过滤
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = null
      }
      this.searchTimeout = setTimeout(() => {
        this.pagination.currentPage = 1
        this.getAllDepartAndMember()
      }, 500)

    },

    async visible(newVal) {
      this.selectMemberVisible = newVal
      if (newVal) {
        await this.getAllDepartAndMember()
        //清空选中的数据,避免错误的数据回显
        this.$refs.tree.setCheckedKeys([])
      } else {
        this.filterText = this.$options.data().filterText
        this.members = this.$options.data().members
        this.treeData = this.$options.data().treeData
        this.pagination.currentPage = 1
      }

    },

    //更新外面传入的值
    selectMemberVisible(newVal) {
      //调用回显页面的数据
      this.$emit("update:visible", newVal)
    },

    moduleUserId(newVal) {
      this.currUserId = newVal
    },

  },

  filters: {
    filterCount(item, that) {
      let obj = {}
      obj.count = 0
      that.computeCount(item.children, obj)
      return obj.count
    },
  },

  mounted() {
    this.currUserId = this.$store.state.userModule.userShare.userId
  },

  methods: {


    computeCount(items, obj) {
      for (let item of items) {
        if (item.isMember) {
          obj.count++;
        } else {
          this.computeCount(item.children, obj)
        }
      }

    },

    reshowPage() {
      let reshowKeys = []
      let nodeCopy = this.members;
      for (let node of nodeCopy) {
        this.recursionReshow(node, reshowKeys)
      }
      this.$nextTick(() => {
        if (reshowKeys) {
          //设置node节点回显数据
          this.$refs.tree.setCheckedKeys(reshowKeys)
        }
      })

    },

    /**
     * 递归回显数据
     * @param parentNode 父节点
     * @param reshowKeys 需要回显的keys
     */
    recursionReshow(parentNode, reshowKeys) {
      if (!parentNode.children || parentNode.children.length === 0) {
        let obj = {}
        obj.count = 0
        //递归统计节点中人的个数
        this.recursionCount(parentNode, obj)
        //如果人不为0个 则回显数据
        if (obj.count) {
          reshowKeys.push(parentNode.id)
        }
      } else {
        for (let parent of parentNode.children) {
          this.recursionReshow(parent, reshowKeys)
        }
      }
    },

    handleCancel() {
      this.filterText = this.$options.data().filterText
      this.members = this.$options.data().members
      this.allCheckNode = this.$options.data().allCheckNode
      this.treeData = this.$options.data().treeData
      this.pagination.currentPage = 1
      this.selectMemberVisible = false
    },

    //因为需要筛选出过滤的父节点以及其所有子节点,只调用element-ui自带的方法只会返回对应的数据,因此需要进行改造筛选条件
    filterNode(value, data, node) {
      if (!value) return true;
      let _array = []; //这里使用数组存储 只是为了存储值。
      this.getReturnNode(node, _array, value);
      let result = false;
      _array.forEach(item => {
        result = result || item;
      });
      return result;
    },
    getReturnNode(node, _array, value) {
      let isPass = false
      if (node.data) {
        if (node.data.label) {
          isPass = node.data.label.indexOf(value) !== -1;
        } else {
          isPass = node.data.name.indexOf(value) !== -1 || node.data.phone.indexOf(value) !== -1;
        }
      }
      isPass ? _array.push(isPass) : "";
      if (!isPass && node.level != 1 && node.parent) {
        this.getReturnNode(node.parent, _array, value);
      }
    },

    handleSizeChange(size){
      this.pagination.pageSize = size
      this.handleChangePage(1)
    },

    async handleChangePage(page) {
      this.pagination.currentPage = page
      await this.getAllDepartAndMember()
      this.reshowPage()

    },

    handleClickSure() {

      if (!this.members.length) {
        this.$message.error("所选机构没有更多参与人或者未选中任何机构")
        return
      }
      let userIds = []
      for (const item of this.members) {
        item.userId = item.id
        userIds.push(item.userId)
      }
      let data = {
        token: cookie.getCookie("token"),
        data: {
          postCode: this.discuss.postCode,
          userIds
        }
      }
      if (this.type === "add") {

        this.isLoading = true
        http.post(window.config.api.baseUrl + '/eims-api/discuss/inviteMember', data).then(response => {
          if (response.data.code === '00000') {
            if (this.currUserId === this.discuss.createUserId) {
              Message.success({message: '用户邀请加入成功', showClose: true})
              this.callback()
              this.selectMemberVisible = false
            } else {
              Message.success({message: '邀请用户信息提交成功', showClose: true})
              this.selectMemberVisible = false
            }

          }
        }).finally(() => {
          this.isLoading = false

        })
      } else {

        this.isLoading = true
        http.post(window.config.api.baseUrl + '/eims-api/discuss/removeMember', data).then(value => {
          if (value.data.code === '00000') {
            Message.success({message: '选中的用户踢出成功', showClose: true})
            this.callback()
          }
          this.selectMemberVisible = false
        }).finally(() => {
          this.isLoading = false

        })
      }
      // this.filterText = this.$options.data().filterText
      this.allCheckNode = this.$options.data().allCheckNode

    },


    /**
     * 修改节点的选中的状态
     */
    handleCheckNode(node, data) {
      let allCheckedValues = this.$refs.tree.getCheckedKeys([data.id])
      if (allCheckedValues.includes(data.id)) {
        allCheckedValues = allCheckedValues.filter(item => {
          return item !== data.id
        })
      } else {
        allCheckedValues.push(data.id)
      }
      this.$refs.tree.setCheckedKeys(allCheckedValues);
      let checkedNodes = this.$refs.tree.getCheckedNodes(false,true);
      let halfCheckedNodes = this.$refs.tree.getCheckedNodes(false,false);
      this.handleTreeNodeCheck(data, {checkedNodes:checkedNodes,halfCheckedNodes:halfCheckedNodes})
    },

    /**
     * 节点的状态改变时触发
     * @param node 当前被选中或取消选中的节点
     * @param checkedNodes 所有被选中的节点
     */
    handleTreeNodeCheck(node, {checkedNodes, halfCheckedNodes}) {

      let result  = []
      this.getMemberData(node,result)
      for (const member of result) {
        let flag = this.isExistMember(member)
        //存在删除
        if (flag){
          //只有半选状态下和全选状态下没有才删除
          if(!checkedNodes.includes(node) && !halfCheckedNodes.includes(node)){
            let members = this.members;
            for (let i = 0; i < members.length; i++) {
              if (member.id === members[i].id){
                this.members.splice(i,1)
                break
              }
            }
          }
          //不存在添加
        } else {
          this.members.push(member)
        }
      }

    },

    //是否存在该用户的信息
    isExistMember(member) {
      for (let item of this.members) {
        if (item.id === member.id){
          return true
        }
      }
      return false
    },

    //获取用户的信息,返回members数组
    getMemberData(node, result = []) {
      if (node.isMember) {
        result.push(node)
      } else {
        if (node.children && node.children.length) {
          let children = node.children;
          for (const child of children) {
            this.getMemberData(child, result)
          }
        }
      }
    },

    recursionCount(item, obj) {
      if (item.isMember) {
        obj.count++;
      } else {
        if (item.children) {
          for (let i = 0; i < item.children.length; i++) {
            this.recursionCount(item.children[i], obj)
          }
        }
      }
    },

    /**
     * 判断节点是否已经被包含.递归查询
     * @param node 需要判断是否存在的节点
     * @param parentData 父节点的数据
     */
    checkNodeIsInclude(node, parentData) {

      let allCheckNode = parentData;
      //标识是否找到
      for (let checkNode of allCheckNode) {
        if (node.isMember) {
          //当前节点是用户
          if (checkNode.id === node.id) {
            this.flag = true
          }

        } else {
          //当前节点是机构
          if (checkNode.value === node.value) {
            this.flag = true
          }

        }
      }

      for (let checkNode of allCheckNode) {
        if (checkNode.children && checkNode.children.length) {
          this.checkNodeIsInclude(node, checkNode.children)
        }
      }

    },

    /**
     * 递归删除集合中的一个项
     * @param node 需要删除的项
     * @param parentNode 所有节点
     */
    deleteIncludeNode(node, parentNode) {

      let allCheckNode = parentNode;
      for (let i = 0; i < allCheckNode.length; i++) {
        let checkNode = allCheckNode[i]
        if (node.isMember) {
          //当前节点是用户
          if (checkNode.id === node.id) {
            //删除改节点的数据
            allCheckNode.splice(i, 1)
            //终止递归
            return
          }

        } else {
          //当前节点是机构
          if (checkNode.value === node.value) {
            //删除改节点的数据
            allCheckNode.splice(i, 1)
            //终止递归
            return
          }
        }
      }

      for (let checkNode of allCheckNode) {
        if (checkNode.children && checkNode.children.length) {
          this.deleteIncludeNode(node, checkNode.children)
        }
      }

    },

    //获取树的数据
    async getAllDepartAndMember() {
      // this.isLoading = true
      let data = {
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        keyword: this.filterText,
        postCode: this.discuss.postCode,
        option: this.type,
      }
      let _this = this;
      this.treeLoading = true;
      this.treeData = []
      let token = cookie.getCookie("token");
      await http.post(window.config.api.baseUrl + '/eims-api/discuss/findAllDepartAndMember', {
        token: token,
        data: data
      }).then(response => {
        if (response.data.code === '00000') {
          let tempTreeData = response.data.data.trees
          this.pagination.total = response.data.data.total
          this.packagingMemberDeptData(tempTreeData)
          this.treeData = tempTreeData
          this.$nextTick(() => {
            if (this.filterText) {
              this.$refs.tree.filter(this.filterText);
            }
          })
        }
      }).finally(() => {
        this.treeLoading = false;
        this.isLoading = false
      })
    },

    /**
     * 递归查找最后一层的机构(科室)的数据,将最后一层的机构(科室)拼接上用户的信息
     * @param allData
     */
    packagingMemberDeptData(allData) {
      for (let data of allData) {
        //设置上节点的id,为了用于回显
        data.id = data.value
        if (data.children) {
          this.packagingMemberDeptData(data.children)
          if (data.addressBooks) {
            for (let addressBook of data.addressBooks) {
              if (addressBook.departmentId === data.id){
                data.children.push({...addressBook, isMember: true})
              }
            }
          }
        } else {
          //设置为最后一层的机构(医院/科室)
          data.endDeptNode = true
          //最后一层的数据
          if (data.addressBooks) {
            data.children = []
            for (let addressBook of data.addressBooks) {
              data.children.push({...addressBook, isMember: true})
            }
          }
        }
      }
    },

  },

  computed: {
    ...mapState({
      moduleUserId: state => state.userModule.userShare.userId,
    }),
  },

}
</script>

<style scoped>

.dialog-wrapper {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.dialog-left-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  flex: 1;
  overflow: hidden;
}

.dialog-right-wrapper {
  width: 30%;
  margin: 10px;
  overflow: auto;


}

.dialog-left-wrapper-head {
  margin: 0 0 10px 0;

}

.dialog-left-wrapper-body {
  flex: 1;
  overflow: auto;
}

.dialog-left-wrapper-footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.dialog-left-wrapper-footer > * {
  margin: 5px 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;

}

.footer-expand > * {
  margin-right: 5px;
}

/* tree的图标 */
/deep/ .el-icon-caret-right:before {
  content: "\e6e0";
}

/* tree的字号 */
/deep/ .el-tree-node__content span {
  font-size: 18px;
}

/deep/ .el-tree-node__content {
  height: 45px;
  font-weight: 400;
}

/* tree的滚动条 */
/deep/ .el-tree {
  width: 100%;
  overflow: scroll;
}

/deep/ .el-tree > .el-tree-node {
  display: inline-block;
  min-width: 100%;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

/deep/ .el-tree {
  background-color: transparent;
}

/deep/ .el-dialog__body {
  height: 70vh;
}

.member-item {
  display: flex;
  flex-direction: column;


}

.member-empty {
  height: calc(100% - 30px);
  font-size: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #bababa;
}

.empty-data-image {
  display: inline-block;
  width: 100px;
  height: 100px;
  background-size: cover;
}

.member-title{
  color: var(--color);
  background-color: #eeeeee;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  margin-bottom: 5px;
}
.dialog-item-panel{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}

.member-item {
  cursor: pointer;
  width: 50px;
  margin: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}

.member-avatar{
  width: 45px;
  height: 45px;
  background-size: cover;
  border: #e8e6e6 2px solid;
  border-radius: 8px;
  align-self: center;
}

.member-name{
  width: 50px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;


}



</style>



// WEBPACK FOOTER //
// src/components/detail/ParticipantDialog.vue